<template>
    <div class="rounded overflow-hidden bg-white shadow">
        <div class="rounded-t p-4 bg-primary-400 text-white">
            <h2 class="font-bold">
                {{ data.house.address }}
            </h2>
            {{ data.house.phone }}
        </div>
        <div v-if="!data.times.length">
            <p class="p-6 text-gray-700">Zavřeno</p>
        </div>
        <div v-else class="py-4">
            <div
                v-for="(time, index) in data.times"
                :key="`${data.house.id}-${index}`"
            >
                <Time
                    :house="data.house"
                    :time="time"
                    :reservations="data.reservations"
                    :last="index === data.times.length - 1"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Time from './Time'
export default {
    props: ['data'],
    components: {
        Time
    }
}
</script>
